export enum SlotPostProcessOption {
  /** Combine adjacent same-type slots into a single longer-duration window. */
  SlotMerge = "slot_merge",
}
